import { render, staticRenderFns } from "./CourseAll.vue?vue&type=template&id=21aed488&"
import script from "./CourseAll.vue?vue&type=script&lang=js&"
export * from "./CourseAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports